import React, { useEffect, useState } from 'react'
import { BarChart } from '@mui/x-charts/BarChart';
import { getCarrerasEstadisticas } from '../../../services/hipodromo';
import { DataEstadisticasInterface } from '../../../interfaces/priximas_carreras.interface';

import Loading from '../../../componetes/loading';
import { MDBCol, MDBRow } from 'mdb-react-ui-kit';



interface Props{
    id: number 
}

const ChartTotal:React.FC<Props> = ({id})=>{
    const [ejemplares, setEjemplares] = useState<DataEstadisticasInterface>()
    
    useEffect(()=>{
        const ejemplar = async () => {
            setEjemplares(await getCarrerasEstadisticas(id))
            
        }
        ejemplar()
        // eslint-disable-next-line
    },[])
    return<>
    <MDBRow>
        <MDBCol>
        { ejemplares ? (
        <>
        <BarChart
            series={[{data: ejemplares.series_total}]}
            height={290}
            // width={'100%'}
            yAxis={[{ 
                data: ejemplares.headers, 
                scaleType: 'band',
                colorMap: {
                    type: 'ordinal',
                    values: ejemplares.headers,
                    colors: [
                        '#ff0000',//1
                        '#dee0df',//2
                        '#0c5ea4',//3
                        '#ffff00',//4
                        '#5b861e',//5
                        '#000000',//6
                        '#ff8a22',//7
                        '#dbaaee',//8
                        '#23a08e',//9
                        '#9066ee',//10
                        '#5b645f',//11
                        '#00ff00',//12
                        '#484030',//13
                        '#a35e55',//14
                        '#f8a235',//15
                        '#89ffd6',//16
                    ],
                  } 
            }]}
            margin={{ top: 10, bottom: 30, left: 125, right: 5 }}
        layout="horizontal"
    />
        </>
    ): (<><Loading/></>)}
        </MDBCol>
    </MDBRow>
    </>
}

export default ChartTotal